/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log("Expanse theme (" + theme.settings.themeVersion + ") by ARCHΞTYPE | Learn more at https://archetypethemes.co");
}

(function () {
  "use strict";

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }

  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');

      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }

      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');

      if (!newAddressForm || !addressForms.length) {
        return;
      }

      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;

          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);

      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;

          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };

  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector('.modal__inner');

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function() {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      try {
        theme.a11y.trapFocus({
          container: this.modal,
          elementToFocus: this.focusOnOpen,
          namespace: 'modal_focus'
        });
      } catch (err) {}

      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition

      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;

      try {
        theme.a11y.removeTrapFocus({
          container: this.modal,
          namespace: 'modal_focus'
        });
      } catch (err) {}

      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');

      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };

    return Modal;
  })();

  theme.Region = (function() {
    let defaults = {
      userCountryKey: 'userCountry',
      ageConsentKey: 'ageConsent',
      redirectUrl: 'redirectUrl',
      finlandIsoCode: 'FI',
      USIsoCode: 'US',
      deIsoCode: 'DE',
      gbIsoCode: 'GB',
      namespace: '.geo-modal',
      currentShopIsoCode: 'FI', // NOTE: This is shop-specific
    };

    let classes = {
      isActive: 'is-active',
      geoToCheck: 'geo-to-check'
    };

    let selectors = {
      geoModal: '.geo-modal',
      storeSwitcher: '[data-store-switcher]',
      ageConsentNo: '.js-age-consent-no',
      ageConsentYes: '.js-age-consent-yes',
      storeSwitcherJs: '.js-store-switcher',
      storeSwitcherModal: '#StoreSwitcherModal'
    };

    function Region(container) {
      this.container = container;
      this.userCountry = sessionStorage.getItem(defaults.userCountryKey);
      this.ageConsent = sessionStorage.getItem(defaults.ageConsentKey) ? sessionStorage.getItem(defaults.ageConsentKey) : false;
      this.skipRedirectOnAccept = false;
      this.geoModal = container.querySelector(selectors.geoModal);
      this.storeSwitcher = document.querySelectorAll(selectors.storeSwitcher);
      this.ageConsentButtonNo = container.querySelector(selectors.ageConsentNo);
      this.ageConsentButtonYes = container.querySelector(selectors.ageConsentYes);
      this.storeSwitcherJs = document.querySelectorAll(selectors.storeSwitcherJs);

      this.urlParams = new URLSearchParams(window.location.search);
      this.currentStore = theme.geoInfo.stores.find(store => store.iso_code == theme.geoInfo.currentIsoCode);

      this.storeSwitcherModal = new theme.Modals('StoreSwitcherModal', 'store-switcher-modal', {
        closeOffContentClick: true,
        solid: true
      });

      this.init();
    }

    Region.prototype = Object.assign({}, Region.prototype, {
      init: function() {
        if (this.isCrawler()) {
          this.removeGeoElements();
          this.showBody();
          return;
        }
        if (theme.settings.disableRegionModal) {
          this.removeGeoElements();
          this.showBody();
          return;
        }

        if (!Shopify.designMode || (this.geoModal.getAttribute('data-debug-mode') == 'true' && Shopify.designMode)) {
          this.setupListeners();
          this.runGeolocationFlow();
        }

        let this2 = this;
        window.showGeoModal = function showGeoModal () {
          this2.showRegionSelection();
          this2.setSelectedCountry(document.querySelector(selectors.storeSwitcher), this2.userCountry || defaults.currentShopIsoCode);
          this2.showGeoModal();
        };

        // Last link in footer, href=/, is the country selector
        document.querySelector('.footer__block.footer__block--menu:first-of-type li:last-of-type a[href="/"]').addEventListener('click', function (event) {
          event.preventDefault();
          window.showGeoModal();
        });
      },

      setupListeners: function () {
        this.ageConsentButtonNo.addEventListener('click', function() {
          this.redirectUser(theme.geoInfo.redirectUrlAgeConsent);
        }.bind(this));

        this.ageConsentButtonYes.addEventListener('click', function() {
          sessionStorage.setItem(defaults.ageConsentKey, true);

          // Genero 16.4.2024: Store selection that was done via country menu.
          if (this.userCountry) {
            sessionStorage.setItem(defaults.userCountryKey, this.userCountry);
          }

          if (!this.skipRedirectOnAccept) {
            this.composeRedirectUrl(this.container.querySelector(selectors.storeSwitcher));
          }

          this.hideGeoModal();
        }.bind(this));

        this.storeSwitcher.forEach(storeSwitcher => {
          storeSwitcher.querySelector('.flag-select__selected').addEventListener('click', function() {
            storeSwitcher.querySelector('.flag-select__options').scrollTop = 0;
            storeSwitcher.querySelector('.flag-select').classList.toggle(classes.isActive);
          }.bind(this));

          storeSwitcher.querySelectorAll('.flag-select__option').forEach(option => {
            option.addEventListener('click', function() {
              this.setSelectedCountry(storeSwitcher, option.getAttribute('data-value'));
              storeSwitcher.querySelector('.flag-select__options').scrollTop = 0;
              storeSwitcher.querySelector('.flag-select').classList.remove(classes.isActive);
            }.bind(this));
          });
        });

        this.storeSwitcherJs.forEach(storeSwitcherElement => {
          storeSwitcherElement.addEventListener('click', function() {
            //this.setSelectedCountry(this.storeSwitcherModal.modal.querySelector(selectors.storeSwitcher), this.userCountry);
            this.storeSwitcherModal.open();
          }.bind(this));
        });

        this.storeSwitcherModal.modal.querySelector('select').addEventListener('change', function() {
          this.composeRedirectUrl(this.storeSwitcherModal.modal.querySelector(selectors.storeSwitcher));
        }.bind(this));

        document.addEventListener('modalClose.StoreSwitcherModal', function() {
          this.storeSwitcherModal.modal.querySelector('.flag-select').classList.remove(classes.isActive);
          this.storeSwitcherModal.modal.querySelector('.flag-select__options').scrollTop = 0;
        }.bind(this));
      },

      runGeolocationFlow: async function () {
        let countryFromUrlParams = this.urlParams.get(defaults.userCountryKey);
        if (countryFromUrlParams) countryFromUrlParams = countryFromUrlParams.toUpperCase()
        let ageConsentFromUrlParams = this.urlParams.get(defaults.ageConsentKey);

        let countryDebugFromGeoModal = this.geoModal.getAttribute('data-debug-iso-code');

        let countryFromGeolocation = await this.fetchGeolocation();

        // From session storage, modal selection, etc.
        let countryFromPreviousSelection = this.userCountry;
        let ageConsentFromPreviousSelection = this.ageConsent;

        let userCountry = countryDebugFromGeoModal || countryFromUrlParams || countryFromPreviousSelection || countryFromGeolocation;

        console.log(
          'country',
          '\n', 'from previous selection', countryFromPreviousSelection,
          '\n', 'from url params:', countryFromUrlParams,
          '\n', 'from geo modal debug:', countryDebugFromGeoModal,
          '\n', 'from geolocation:', countryFromGeolocation,
          '\n', '=', userCountry
        );

        // Genero 16.4.2024: Do not store 'undefined' as the country if geo location fails.
        if (userCountry) {
          this.userCountry = userCountry;
          sessionStorage.setItem(defaults.userCountryKey, this.userCountry);
        }

        // Detected country matches shop country - stay on page
        if (this.userCountry?.toUpperCase() === defaults.currentShopIsoCode) {
          if (this.userCountry && this.ageConsent) {
            this.showBody();
          } else if (countryFromUrlParams && ageConsentFromUrlParams) {
            sessionStorage.setItem(defaults.userCountryKey, this.urlParams.get(defaults.userCountryKey));
            sessionStorage.setItem(defaults.ageConsentKey, this.urlParams.get(defaults.ageConsentKey));
            this.showBody();
          } else {
            // Genero 16.4.2024: Default to current shop in case geo location failed.
            this.setSelectedCountry(this.container.querySelector(selectors.storeSwitcher), countryFromGeolocation || this.userCountry || defaults.currentShopIsoCode);
            this.hideRegionSelection();
            this.showGeoModal();
          }
          return
        }

        // FI, DE, US redirects
        // for (const [countryCode, countryUrl] of [
        //   [defaults.finlandIsoCode, 'https://www.kyrodestillery.com'],
        //   [defaults.deIsoCode, 'https://www.kyrodistillery.de'],
        //   [defaults.USIsoCode, 'https://www.kyrodistillery.com']
        // ]) {
        //   if (this.userCountry?.toUpperCase() === countryCode) {
        //     this.redirectUserWithCountry(countryUrl, countryCode)
        //     return;
        //   }
        // }

        // Default to GB, unless already there
        // if (defaults.currentShopIsoCode !== 'GB') {
        //   this.redirectUser('https://www.kyrodistillery.co.uk', 'GB');
        //   return;
        // }

        // If all else fails, set default country and show modal
        this.setSelectedCountry(this.container.querySelector(selectors.storeSwitcher), countryFromGeolocation || this.userCountry || defaults.currentShopIsoCode);
        this.showGeoModal();
      },

      fetchGeolocation: async function() {
        try {
          const response = await fetch(theme.geoInfo.enpointUrl);
          const data = await response.json();
          const { token } = data;
          const payload = token.split('.')[1];
          const js = JSON.parse(atob(payload));

          return js.countryCode;
        } catch(err) {
          console.log(err);
        }
      },

      setSelectedCountry: function (storeSwitcher, isoCode) {
        let found = false;
        let select = storeSwitcher.querySelector('select');
        let flagSelect = storeSwitcher.querySelector('.flag-select');
        let flagSelected = storeSwitcher.querySelector('.flag-select__selected');
        let currentIsoCode = '';

        flagSelect.querySelectorAll('.flag-select__option').forEach(option => {
          if (option.getAttribute('data-value') == isoCode) {
            currentIsoCode = isoCode;
            flagSelected.innerHTML = option.innerHTML;
            found = true;
          }
        });

        if (!found) {
          if (flagSelect.querySelector(`.flag-select__option[data-value="${defaults.gbIsoCode}"]`)) {
            flagSelected.innerHTML = flagSelect.querySelector(`.flag-select__option[data-value="${defaults.gbIsoCode}"]`).innerHTML;
            currentIsoCode = defaults.gbIsoCode;
          } else {
            flagSelected.innerHTML = flagSelect.querySelectorAll('.flag-select__option')[0].innerHTML;
            currentIsoCode = flagSelect.querySelectorAll('.flag-select__option')[0].getAttribute('data-value');
          }
        }

        // Genero 16.4.2024: Store manual country selection.
        this.userCountry = currentIsoCode;

        select.value = currentIsoCode;
        select.dispatchEvent(new Event('change'));
      },

      removeGeoElements: function () {
        this.storeSwitcher.forEach(storeSwitcher => {
          storeSwitcher.remove();
        });

        this.storeSwitcherJs.forEach(storeSwitcherElement => {
          storeSwitcherElement.remove();
        });
      },

      showGeoModal: function () {
        this.geoModal.classList.add(classes.isActive);
        try {
          theme.a11y.lockMobileScrolling(defaults.namespace);
        } catch (err) {}
      },

      hideGeoModal: function () {
        this.geoModal.classList.remove(classes.isActive);
        this.showBody();
        theme.pageTransitions();
      },

      hideRegionSelection: function () {
        this.skipRedirectOnAccept = true;
        var bannerSwitcher = this.container.querySelector(selectors.storeSwitcher);
        if (bannerSwitcher) {
          bannerSwitcher.style.display = 'none';
        }
      },

      showRegionSelection: function () {
        this.skipRedirectOnAccept = false;
        var bannerSwitcher = this.container.querySelector(selectors.storeSwitcher);
        if (bannerSwitcher) {
          bannerSwitcher.style.display = '';
        }
      },

      showBody: function () {
        document.body.classList.remove(classes.geoToCheck);
        try {
          theme.a11y.unlockMobileScrolling(defaults.namespace);
        } catch (err) {}
      },

      isCrawler: function () {
        return /Googlebot|Google-InspectionTool|Storebot-Google|GoogleOther|AdsBot-Google|Mediapartners-Google|APIs-Google/i.test(navigator.userAgent);
      },

      composeRedirectUrl: function (storeSwitcher) {
        let selectedCountryIsoCode = storeSwitcher.querySelector('select').value;
        let selectedStore = theme.geoInfo.stores.find(store => store.iso_code == selectedCountryIsoCode);

        if (selectedCountryIsoCode && selectedCountryIsoCode != theme.geoInfo.currentIsoCode) {
          let url = new URL(selectedStore.url);

          // Preserve path if it starts with /directlink/ or /products/
          if (window.location.pathname.startsWith('/directlink/') || window.location.pathname.startsWith('/products/')) {
            url.pathname = window.location.pathname;
          }

          let reservedParams = [defaults.userCountryKey, defaults.ageConsentKey, defaults.redirectUrl];
          new URLSearchParams(window.location.search).forEach(function(value, key) {
            if (!reservedParams.includes(key)) {
              url.searchParams.append(key, value);
            }
          });
          url.searchParams.append(defaults.userCountryKey, this.userCountry);
          url.searchParams.append(defaults.ageConsentKey, true);

          this.redirectUser(url.href);
        }
      },

      redirectUserWithCountry: function (storeUrl, country) {
        let url = new URL(storeUrl);

        // Preserve path if it starts with /directlink/ or /products/
        if (window.location.pathname.startsWith('/directlink/') || window.location.pathname.startsWith('/products/')) {
          url.pathname = window.location.pathname;
        }

        url.searchParams.append(defaults.userCountryKey, country);
        this.redirectUser(url.href);
      },

      redirectUser: function (url) {
        window.location.href = url;
      }
    });

    return Region;
  })();

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent("page:loaded"));

    var geoModal = document.getElementById('GeoModal');
    new theme.Region(geoModal);
  });
})();
